export const channelEmojis = [
  {
    id: 'channels',
    name: 'Channels',
    emojis: [
      {
        id: 'facebook_ads',
        name: 'Facebook',
        keywords: ['face', 'book', 'facebook', 'social'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702300706/Channel%20Emojis/cgwmks9xn9o0fzszgqyf.svg',
          },
        ],
      },
      {
        id: 'instagram_posts',
        name: 'Instagram',
        keywords: ['instagram', 'ads', 'posts'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702319405/Channel%20Emojis/sqzkkxfgyflsaameqna9.svg',
          },
        ],
      },
      {
        id: 'linkedin_ads',
        name: 'LinkedIn',
        keywords: ['linked', 'ads', 'posts'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702319585/Channel%20Emojis/skt1unhmz6enewuvbgne.svg',
          },
        ],
      },
      {
        id: 'tiktok_ads',
        name: 'TikTok Ads',
        keywords: ['tiktok', 'tik', 'tok', 'ads', 'posts'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702319460/Channel%20Emojis/lkzpyadyu8fh6mac6h7u.svg',
          },
        ],
      },
      {
        id: 'tweets',
        name: 'X',
        keywords: ['x', 'twitter', 'tweets'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702319530/Channel%20Emojis/d6agvplvbuzacjtcfef1.svg',
          },
        ],
      },
      {
        id: 'youtube_ads',
        name: 'Youtube',
        keywords: ['youtube', 'ads', 'scripts', 'video'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702319613/Channel%20Emojis/uksf76a2vjom9gphnhmc.svg',
          },
        ],
      },
      {
        id: 'google_ads',
        name: 'Google',
        keywords: ['google', 'ads', 'product', 'launch'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702316714/Channel%20Emojis/ej1m1muybxau4fxiodh8.svg',
          },
        ],
      },
      {
        id: 'amazon_ads',
        name: 'Amazon',
        keywords: ['amazon', 'ads', 'product', 'launch'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702316560/Channel%20Emojis/lhygrcd4blhzgqptuody.svg',
          },
        ],
      },
      {
        id: 'product_launch_shopify',
        name: 'Shopify',
        keywords: ['product', 'launch', 'shopify'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702316618/Channel%20Emojis/upmo2wehhqxau930cnhj.svg',
          },
        ],
      },
      {
        id: 'product_launch_website',
        name: 'Website',
        keywords: ['website', 'product', 'launch', 'square', 'space'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702316267/Channel%20Emojis/jihehcrus5as5raqjuyq.svg',
          },
        ],
      },
      {
        id: 'product_launch_etsy',
        name: 'Etsy',
        keywords: ['product', 'launch', 'etsy'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702316678/Channel%20Emojis/rdkf3doieoh7ub5e5eo9.svg',
          },
        ],
      },
      {
        id: 'blog_post',
        name: 'Blog Post',
        keywords: ['blog', 'post', 'blog_post'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702318610/Channel%20Emojis/zvftswpy8hqo72ng5wzk.svg',
          },
        ],
      },
      {
        id: 'brainstorm',
        name: 'Brainstorm',
        keywords: ['brain', 'storm', 'brainstorm', 'blog', 'ideas'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702311185/Channel%20Emojis/iqizv6peyqv7zdydmo3x.svg',
          },
        ],
      },
      {
        id: 'landing_page',
        name: 'Landing Page',
        keywords: ['landing', 'page', 'landing page'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702310766/Channel%20Emojis/hkduicdiapmhexuxoi3z.svg',
          },
        ],
      },
      {
        id: 'about_us',
        name: 'About Us',
        keywords: ['about', 'us', 'about us'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702311908/Channel%20Emojis/majqzpu6xkeutdfd8ifr.svg',
          },
        ],
      },
      {
        id: 'pricing',
        name: 'Pricing',
        keywords: ['pricing', 'price'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702311796/Channel%20Emojis/vgs7nishlkajunm74mxl.svg',
          },
        ],
      },
      {
        id: 'faqs',
        name: 'Faqs',
        keywords: ['faq', 'faqs', 'frequently', 'asked', 'questions'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702312460/Channel%20Emojis/chzlb25vbwmp966yl3np.svg',
          },
        ],
      },
      {
        id: 'mission',
        name: 'Mission',
        keywords: ['mission'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702311997/Channel%20Emojis/julzp4zfiwvoisptx6ww.svg',
          },
        ],
      },
      {
        id: 'impact',
        name: 'Impact',
        keywords: ['impact'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702311997/Channel%20Emojis/cfpudzpkzqmoohcknhv9.svg',
          },
        ],
      },
      {
        id: 'promotional_email_sequence',
        name: 'Discount Email',
        keywords: ['promotional_email_sequence', 'promo', 'email', 'discount'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702311997/Channel%20Emojis/c3hlrvrpguk0nhktah1q.svg',
          },
        ],
      },
      {
        id: 'candidate_nurture_sequence',
        name: 'Candidate Nurture',
        keywords: ['candidate_nurture_sequence', 'candidate', 'nurture', 'candidate nurture'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702312501/Channel%20Emojis/mqammnfx3cnfe7xrb7bo.svg',
          },
        ],
      },
      {
        id: 'case_study',
        name: 'Case Study',
        keywords: ['case', 'study', 'case study'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702318667/Channel%20Emojis/q1xsyb5otqxgwfkjuk9s.svg',
          },
        ],
      },
      {
        id: 'press_release',
        name: 'Press Release',
        keywords: ['press', 'release', 'press release'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702318821/Channel%20Emojis/k6n9o3ncvs7anmdidmjv.svg',
          },
        ],
      },
      {
        id: 'outline',
        name: 'Content Outline',
        keywords: ['content', 'outline', 'content outline'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702318872/Channel%20Emojis/coadacigvsgu9b1j5s0c.svg',
          },
        ],
      },
      {
        id: 'content_brief',
        name: 'Content Brief',
        keywords: ['content', 'brief', 'content brief'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702318964/Channel%20Emojis/qztz4sslzwc5rwqldrut.svg',
          },
        ],
      },
      {
        id: 'cold_outbound_email_sequence',
        name: 'Cold Outbound',
        keywords: ['cold', 'outbound'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702319231/Channel%20Emojis/los54jezm3kg0fgjwy72.svg',
          },
        ],
      },
      {
        id: 'warm_outbound_email_sequence',
        name: 'Warm Outbound',
        keywords: ['warm', 'outbound'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702319255/Channel%20Emojis/jgkeb2y7bf8gh48ovmg3.svg',
          },
        ],
      },
      {
        id: 'sms_messages',
        name: 'SMS Messages',
        keywords: ['sms', 'messages'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702319288/Channel%20Emojis/me0rtytjxu7ngtepuj7r.svg',
          },
        ],
      },
      {
        id: 'newsletter',
        name: 'Newsletter',
        keywords: ['newsletter'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702320643/Channel%20Emojis/z7a6crr2wfamf9y2uav5.svg',
          },
        ],
      },
      {
        id: 'newsletter_ideas',
        name: 'Newsletter Ideas',
        keywords: ['newsletter', 'ideas'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702320938/Channel%20Emojis/nfkcouz2uagq6hzq5oix.svg',
          },
        ],
      },
      {
        id: 'nurture_email_sequence',
        name: 'Nurture Sequence',
        keywords: ['nurture', 'email', 'sequence', 'candidate'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702320965/Channel%20Emojis/slkcjxrbj0idqrf86nc5.svg',
          },
        ],
      },
      {
        id: 'welcome_series',
        name: 'Welcome Series',
        keywords: ['welcome', 'series'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702320989/Channel%20Emojis/sc7jilnj9je6niuw1zx0.svg',
          },
        ],
      },
      {
        id: 'didnt_sign_up',
        name: "Didn't Sign Up",
        keywords: ['didnt', 'sign', 'up'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702321011/Channel%20Emojis/r1djvg7k1u3bq4qdnzus.svg',
          },
        ],
      },
      {
        id: 'abandoned_cart',
        name: 'Abandoned Cart',
        keywords: ['abandoned', 'cart'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702321039/Channel%20Emojis/uswk5cpmk5qaykqvndy8.svg',
          },
        ],
      },
      {
        id: 'lost_customer',
        name: 'Lost Customer',
        keywords: ['lost', 'customer'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702321078/Channel%20Emojis/kj0l8hepghhj2my8sx0s.svg',
          },
        ],
      },
      {
        id: 'one_pager',
        name: 'One Pager',
        keywords: ['one', 'pager'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702321886/Channel%20Emojis/pumf7dtk0vztivlru7is.svg',
          },
        ],
      },
      {
        id: 'battle_card',
        name: 'Battle Card',
        keywords: ['battle', 'card'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702321904/Channel%20Emojis/hnvrcxvlg1j0hi0zkqft.svg',
          },
        ],
      },
      {
        id: 'testimonial',
        name: 'Testimonial',
        keywords: ['testimonial'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702321938/Channel%20Emojis/xro5eps7vmdmhm1lzghl.svg',
          },
        ],
      },
      {
        id: 'product_demo',
        name: 'Product Demo',
        keywords: ['product', 'demo'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702321965/Channel%20Emojis/dbtdxawkupb5e5nur52i.svg',
          },
        ],
      },
      {
        id: 'pre_call_checklist',
        name: 'Pre Call Checklist',
        keywords: ['pre', 'call', 'checklist'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702321997/Channel%20Emojis/nmku7dabbg70ol4bpegu.svg',
          },
        ],
      },
      {
        id: 'call_script',
        name: 'Call Script',
        keywords: ['call', 'Script'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702322031/Channel%20Emojis/hwvsfqw8xxobjgnfylgx.svg',
          },
        ],
      },
      {
        id: 'research',
        name: 'research',
        keywords: ['research'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702321857/Channel%20Emojis/kk6rf5te7eiqhvbtfocm.svg',
          },
        ],
      },

      {
        id: 'reply_templates',
        name: 'Reply Templates',
        keywords: ['reply', 'templates'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702322904/Channel%20Emojis/ehaphzi2sfwcjvlftakb.svg',
          },
        ],
      },
      {
        id: 'help_docs',
        name: 'Help Docs',
        keywords: ['help', 'docs'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702322959/Channel%20Emojis/w9h9bpqjnbqynjrvhmjo.svg',
          },
        ],
      },
      {
        id: 'return_policy',
        name: 'Return Policy',
        keywords: ['return', 'policy'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702322969/Channel%20Emojis/icvfrzwdviixq1jqrkyh.svg',
          },
        ],
      },
      {
        id: 'shipping_policy',
        name: 'Shipping Policy',
        keywords: ['shipping', 'policy'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702322988/Channel%20Emojis/af2m9gwg7kuz9531he1m.svg',
          },
        ],
      },
      {
        id: 'care_instructions',
        name: 'Care Instructions',
        keywords: ['care', 'instructions'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702323057/Channel%20Emojis/um0fx1f3irn0fu6ya4v2.svg',
          },
        ],
      },
      {
        id: 'billing_and_payments',
        name: 'Billing and Payment',
        keywords: ['billing', 'payment'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702323096/Channel%20Emojis/p45vh5k4teye2miuc5sb.svg',
          },
        ],
      },
      {
        id: 'payment_confirmation',
        name: 'Payment Confirmation',
        keywords: ['payment', 'confirmation'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702323099/Channel%20Emojis/kvq4lqb4uturlujgbe2t.svg',
          },
        ],
      },
      {
        id: 'youtube_short',
        name: 'YouTube Short',
        keywords: ['youtube', 'short', 'ads', 'scripts', 'video'],
        skins: [
          {
            src: 'https://res.cloudinary.com/almanac/image/upload/v1702319613/Channel%20Emojis/uksf76a2vjom9gphnhmc.svg',
          },
        ],
      },
    ],
  },
]
